export const getPlatforms = (config, experimentGroup, regionId) => {
  const multiPostingPlatforms = config.get('addformConfig.multiPosting.platforms');

  if (!regionId || !multiPostingPlatforms[regionId]) {
    return [];
  }

  const regionData = multiPostingPlatforms[regionId];
  if (experimentGroup === 'B') {
    return regionData.paid.concat(regionData.free);
  } else if (experimentGroup === 'C') {
    return regionData.free;
  }

  return [];
};
